import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ title?: string | JSX.Element }>()(
  (theme, { title }) => ({
    root: {
      width: '100%',
    },
    title: {
      fontSize: '16px',
      lineHeight: theme.spacing(3),
      color: theme.palette.textField.dark,
    },
    value: {
      fontSize: '14px',
      lineHeight: theme.spacing(2.625),
      color: theme.palette.labraText.secondaryDescription,
      fontWeight: 500,
      paddingTop: theme.spacing(title ? 0.5 : 0),
    },
    description: {
      fontSize: '11px',
      lineHeight: theme.spacing(2),
      fontWeight: 500,
      color: theme.palette.labraText.description,
      paddingTop: theme.spacing(1.5),
    },
  })
)
